var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpellbookIcon = function SvgSpellbookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46,
    fill: "none",
    viewBox: "0 0 48 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.695 8.016-.406-1.554c-.03-.11-.185-.113-.216-.005l-.467 1.536a.11.11 0 0 1-.08.077l-1.553.406c-.11.03-.113.185-.005.216l1.536.467q.06.018.077.08l.406 1.553c.03.11.185.113.216.005l.467-1.536a.11.11 0 0 1 .08-.077l1.553-.406c.11-.03.113-.185.005-.216M38.081 5.119l2.83-.792c.201-.056.201-.34 0-.397l-2.827-.807a.2.2 0 0 1-.143-.142L37.149.15c-.057-.201-.34-.201-.397 0l-.808 2.828a.2.2 0 0 1-.142.142l-2.83.791c-.2.057-.2.34 0 .397l2.828.808c.07.02.124.074.142.142l.794 2.83c.056.2.34.2.397 0l.807-2.828a.2.2 0 0 1 .142-.142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.993,
    d: "m6.913 30.991-4.151 2.366 19.973 10.902 24.238-15.44-3.84-1.796"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.993,
    d: "M2.762 21.671 27.805 8.17l19.168 8.964-24.238 15.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.993,
    d: "M2.695 33.286c-1.646-2.59-2.832-6.752.072-11.616M6.715 23.817v6.576l16.044 9.168 20.03-12.655v-6.777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M34.732 17.272a7.55 7.55 0 0 1-7.093-6.011 28.2 28.2 0 0 1-12.592 8.092l-6.64 2.072 5.956-.254a8.464 8.464 0 0 1 8.792 7.728A24.19 24.19 0 0 1 37.642 18.5l3.848-.963zm-6.697 3.393-2.536-.757a.33.33 0 0 0-.202.005l-2.625.909c-.19.064-.384-.047-.277-.155l1.524-1.53c.037-.037.043-.083.007-.117l-1.364-1.446c-.096-.105.113-.227.291-.173l2.536.757c.06.019.14.018.201-.005l2.626-.909c.19-.064.384.047.276.155l-1.523 1.53c-.037.037-.043.084-.008.117l1.365 1.447c.096.104-.113.226-.291.172",
    clipRule: "evenodd"
  })));
};
export default SvgSpellbookIcon;